const outdated_flash = () => {
  const flash = document.querySelector('.zusp-outdated-version');
  const message = document.querySelector('.document-warning');
  if (!flash || !message) {
    return;
  }

  const CSS_SELECTOR = 'show-outdated-message';

  var callback = function (entries, observer) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        document.documentElement.classList.remove(CSS_SELECTOR);
      } else {
        document.documentElement.classList.add(CSS_SELECTOR);
      }

    });
  };

  const observer = new IntersectionObserver(callback, {threshold: 1.0});
  observer.observe(message);


}

export {outdated_flash};
